import { render, staticRenderFns } from "./page-userList.vue?vue&type=template&id=f0bd14e0&scoped=true&"
import script from "./page-userList.vue?vue&type=script&lang=js&"
export * from "./page-userList.vue?vue&type=script&lang=js&"
import style0 from "./page-userList.vue?vue&type=style&index=0&id=f0bd14e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bd14e0",
  null
  
)

export default component.exports